var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.props.as,{tag:"component",class:_setup.editorBoxRecipe({
      tone: _setup.props.tone,
      isFocused: _setup.props.isFocused,
      isDisabled: _setup.props.isDisabled,
      isUnstyled: _setup.props.isUnstyled,
    }),attrs:{"data-component":"CsEditorBox","data-disabled":_setup.props.isDisabled,"data-focused":_setup.props.isFocused}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }